import { UserLayout } from "@/src/layouts/UserLayout";
import { Metrics, Balance, Boosts, RechargeBalance, Tvl } from "@/src/views/home";

export const Dashboard = () => {
  return (
    <UserLayout>
      <div className="max-w-5xl w-full mx-auto p-4 sm:p-5 lg:p-8 space-y-6">
        <h1 className="text-2xl font-bold text-foreground">Dashboard</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <Tvl />
          <Balance />
          <Boosts />
          <RechargeBalance />
        </div>
        <Metrics />
      </div>
    </UserLayout>
  );
};
